import { Pipe } from '@angular/core';
import { isObject, getKeysTwoObjects, isDeepEqual } from '../helpers/helpers';
var DiffObjPipe = (function () {
    function DiffObjPipe() {
    }
    DiffObjPipe.prototype.transform = function (obj, original) {
        if (original === void 0) { original = {}; }
        if (Array.isArray(obj) || Array.isArray(original) || !isObject(obj) || !isObject(original)) {
            return {};
        }
        return getKeysTwoObjects(obj, original).reduce(function (diff, key) {
            return (!isDeepEqual(original[key], obj[key]) ? diff[key] = obj[key] : {}), diff;
        }, {});
    };
    return DiffObjPipe;
}());
export { DiffObjPipe };
DiffObjPipe.decorators = [
    { type: Pipe, args: [{ name: 'diffObj' },] },
];
/** @nocollapse */
DiffObjPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=diff-obj.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/diff-obj.js
// module id = 246
// module chunks = 4